import './style.css';
import { AiOutlineDownload } from "react-icons/ai";
import { utils, writeFile } from 'xlsx';

const ExcelDownloadButton = (props) => {
    const { data } = props;
    const handleDownload = () => {
        if (!data || data.length === 0) {
            alert("No hay datos para descargar");
            return;
        }

        const headers = ["Descripción", "Cantidad", "Precio Unitario", "Total", "Valor impuesto", "Tasa impuesto", "SKU"];

        const rows = data.map(row => {
            const relatedItem = row.relatedItem || {};
            // El impuesto puede venir como 'tax' o 'Valor impuesto' depende si es XML o Excel previo
            const tax = row.tax ?? row['Valor impuesto'] ?? 0;
            const taxRate = row.taxRate ?? row.tax_rate ?? row['Tasa impuesto'] ?? 0;
            const quantity = row.quantity ?? row['Cantidad'] ?? 0;
            const price = row.unit_price ?? row.price ?? row['Precio Unitario'] ?? 0;
            const total = row.total ?? row['Total'] ?? 0;
            const description = row.description ?? row['Descripción'] ?? '';

            return [
                description,
                quantity,
                price,
                total,
                tax,
                taxRate,
                relatedItem.sku || row.sku || row.SKU || ''
            ];
        });

        const worksheetData = [headers, ...rows];
        const worksheet = utils.aoa_to_sheet(worksheetData);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, "Datos");
        writeFile(workbook, "related_data.xlsx");
    };

    if (props.component) {
        return <props.component onClick={handleDownload}>{props.children || "Descargar plantilla"}</props.component>;
    }

    return (
        <button
            onClick={handleDownload}
            className="btn-download-xlsx"
        >
            <AiOutlineDownload /> Descargar plantilla
        </button>
    );
};

export default ExcelDownloadButton;
